import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_FILTERS';

const en = {
    yes: 'Checked',
    no: 'Unchecked',
    mustFillAll: 'Both fields must be filled'
};

const he = {
    yes: 'תיבה מסומנת',
    no: 'תיבה לא מסומנת',
    mustFillAll: 'יש למלא את שני השדות'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'yes',
    2: 'no',
    3: 'mustFillAll'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
